import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";

interface UserSearchBarProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  totalCount: number;
  filteredCount: number;
}

export function UserSearchBar({
  searchQuery,
  onSearchChange,
  totalCount,
  filteredCount,
}: UserSearchBarProps) {
  return (
    <div className="flex items-center gap-4">
      <div className="relative max-w-sm flex-1">
        <Search className="text-muted-foreground absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2" />
        <Input
          placeholder="Search users..."
          value={searchQuery}
          onChange={(e) => {
            onSearchChange(e.target.value);
          }}
          className="pl-10"
        />
      </div>
      <div className="flex items-center gap-2">
        <p className="text-muted-foreground text-sm">
          {filteredCount} of {totalCount} user
          {filteredCount !== 1 ? "s" : ""} {searchQuery ? "found" : ""}
        </p>
      </div>
    </div>
  );
}
